module.exports = ".advanced-search {\n  border-bottom: 1px solid #edf0f4;\n  margin: -0.5em 1.5em 1em 0;\n  padding-bottom: 1em;\n}\n\n.advanced-search .clear-search {\n  margin-right: 32px;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.btnSearch {\n  width: 100%;\n}\n\n.searchContainer {\n  padding: 0;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/abastecimento-bens/abastecimento-bem-list/abastecimento-bem-list.component.css
 ** module id = 410
 ** module chunks = 0
 **/